'use client';

import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useSiteConfig } from '@/context/SiteConfigContext';
import ContinueLendo from '@/components/obra/ContinueLendo';
import AtualizadosRecentes from '@/components/obra/AtualizadosRecentes';
import ObrasHome from '@/components/obra/ObrasHome';
import RecentesCriadas from '@/components/obra/RecentesCriadas';
import FavoritadasRecentes from '@/components/obra/FavoritadasRecentes';
import HomeTagsExplore from '@/components/home/HomeTagsExplore';
import StatusVip from '@/components/user/StatusVip';
import HomeAppButton from '@/components/layout/HomeAppButton';

type HomePageProps = { formatoId?: number };

export default function HomePage({ formatoId: formatoIdProp }: HomePageProps = {}) {
    const { isAuthenticated, user, isLoading } = useAuth();
    const { requireVipToAccess, loading: configLoading } = useSiteConfig();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [selectedFormato, setSelectedFormato] = useState(() => {
        if (typeof formatoIdProp === 'number' && Number.isInteger(formatoIdProp) && formatoIdProp > 0) {
            return formatoIdProp;
        }
        const f = searchParams.get('formato');
        if (f) {
            const n = Number(f);
            if (!Number.isNaN(n) && Number.isInteger(n)) return n;
        }
        return 5;
    });

    // Atualizar URL quando o formato mudar
    useEffect(() => {
        if (!Number.isNaN(selectedFormato) && Number.isInteger(selectedFormato)) {
            const params = new URLSearchParams(searchParams.toString());
            if (params.get('formato') !== String(selectedFormato)) {
                params.set('formato', String(selectedFormato));
                navigate(`?${params.toString()}`, { replace: true });
            }
        }
    }, [selectedFormato, navigate, searchParams]);

    const mustRedirectToLanding = !isAuthenticated || (requireVipToAccess && !user?.is_vip);

    if (isLoading || configLoading || (mustRedirectToLanding && typeof window !== 'undefined')) {
        return null;
    }

    // Bolas decorativas
    const isEnTheme = selectedFormato === 1;
    const shadowClass = isEnTheme
        ? 'rounded-full opacity-[0.25] animate-float blur-3xl pointer-events-none z-0 bg-blue-500'
        : 'rounded-full bg-gradient-to-br from-[#ff6b35] to-[#e55a2b] opacity-[0.25] animate-float blur-3xl pointer-events-none z-0';

    const DecorativeShadows = () => (
        <>
            <div className={`fixed top-[-100px] left-[-100px] w-[200px] h-[200px] ${shadowClass}`} />
        </>
    );

    return (
        <main
            className="min-h-screen relative overflow-x-hidden"
            data-theme={isEnTheme ? 'en' : undefined}
        >
            <DecorativeShadows />

            <div className="max-w-7xl mx-auto px-4 md:px-8 pt-0 lg:pt-24 pb-12 lg:pb-20 relative z-10">
                <div className="mb-8">
                    <ObrasHome formatoId={selectedFormato} onFormatoChange={setSelectedFormato} />
                </div>

                {/* <StatusVip /> */}

                <HomeAppButton />

                <ContinueLendo formatoId={selectedFormato} />

                <FavoritadasRecentes formatoId={selectedFormato} />

                <RecentesCriadas formatoId={selectedFormato} controlledFormato />

                <AtualizadosRecentes formatoId={selectedFormato} />

                {/* <HomeTagsExplore formatoId={selectedFormato} /> */}
            </div>
        </main>
    );
}
